class ProductImagesGallery {
    constructor($el) {
        this.$el = $el;

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        this.$images = this.$el.find('.product-details__images-gallery-thumbnail');
        this.$mainImage = this.$el.find('.product-details__images-gallery-main-image');

        if(this.$images.length && this.$mainImage.length) {
            this._bindEvents();
        }
    }

    _bindEvents() {
        this.toggleSrcFn = this._toggleSrc.bind(this);

        this.$images.on('click', this.toggleSrcFn);
    }

    _toggleSrc(e) {
        const $target = $(e.currentTarget);

        if($target) {
            const index = $target.parent().index();
            const targetSrc = this.$images.eq(index).attr('src');

            this.$mainImage.attr('src', targetSrc);
        }
    }
}

export default ProductImagesGallery;
